/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-17 16:34:50
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import Input from 'src/types/iview/Input';
 import { Toast } from 'src/util/toast';
 import { modalFactory } from 'src/util/vueExtend';
 import SnConfigApi, { SnConfigDOI } from './api/snConfigApi';
 import { Integer } from 'src/types/base';
 import { createNamespace } from 'src/util/bem';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import EnumSex from 'src/enums/enumSex';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import EnumEntity from 'src/enums/enumEntity';
 import EnumOperates from 'src/enums/enumOperates';
 import RegexCheck from 'src/util/regexCheck';
 import IconCustom from 'src/components/icon/iconCustom';

 export namespace SnOperateVOI {
    export interface PropsI {
        operate: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        user_name: string;
        user_phone: string;
    }
 }

 @Component
 class SnOperateModal extends Vue.Component<SnOperateVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: SnOperateVOI.FormDataI = {
        user_name: '',
        user_phone: '',
    };

    rules: any = {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        let params: SnConfigDOI.OperateParamsI = {
            ...this.formData,
        };
        params.id = this.id;
        res = await SnConfigApi.update(params);
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success("修改成功");
            this.saveSuccess();
            this.closeModal();
        }
    }
    
    render(h) {
        return (
            <Modal
                class={createNamespace('modal')}
                title={"修改"}
                width="800"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
                footer-hide={EnumOperates.Detail.getName()===this.operate}
            >
                <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="客户姓名" prop="user_name" style="display: inline-block;width:45%">
                        <Input  placeholder="请输入" v-model={this.formData.user_name} />
                    </form-item>
                    <form-item label="手机号" prop="user_phone" style="display: inline-block;width:45%">
                        <Input  placeholder="请输入" v-model={this.formData.user_phone} />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
 }


 export default function alertSnOperateModal(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<SnOperateVOI.PropsI>(SnOperateModal)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
 }


